import styled from '@emotion/styled';
import Button from '@base/Button/Button';
import H2 from '@base/H2/H2';
import H5 from '@base/H5/H5';
import P1 from '@base/P1/P1';
import P2 from '@base/P2/P2';
import Image from '@base/Image';
import { Spacings, Fonts } from '@styles/index';
import { PARENT_PROGRESS_BENEFITS } from './ParentProgressBenefits';
import {
  formatPhoneDisplay,
  ParentContactCountry
} from './parentContactVerificationUtils';

interface ParentContactVerificationSuccessProps {
  country: ParentContactCountry | null;
  phone: string;
  onContinue: () => void;
}

const SuccessCard = styled.div`
  margin: 0;
  padding: 0;
`;

const SuccessIconWrapper = styled.div`
  margin-bottom: ${Spacings.SPACING_2B};
`;

const SuccessDescription = styled(P1)`
  margin-top: ${Spacings.SPACING_3B};
  color: var(--color-text-secondary);
  line-height: ${Fonts.PARA_LINE_HEIGHT};
`;

const BenefitsList = styled.div`
  margin-top: ${Spacings.SPACING_8B};
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_6B};
`;

const BenefitItem = styled.div`
  display: grid;
  grid-template-columns: ${Spacings.SPACING_8B} 1fr;
  grid-column-gap: ${Spacings.SPACING_4B};
  align-items: flex-start;
`;

const BenefitIcon = styled.div`
  width: ${Spacings.SPACING_8B};
  height: ${Spacings.SPACING_8B};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const BenefitTitle = styled(H5)`
  font-weight: ${Fonts.SEMIBOLD};
  margin: 0;
`;

const BenefitDescription = styled(P2)`
  margin-top: ${Spacings.SPACING_1B};
  color: var(--color-text-secondary);
  font-weight: ${Fonts.LIGHT};
`;

const SuccessContinueButton = styled(Button)<any>`
  margin-top: ${Spacings.SPACING_8B};
  width: fit-content;
  min-width: 140px;
`;

const ParentContactVerificationSuccess = ({
  country,
  phone,
  onContinue
}: ParentContactVerificationSuccessProps) => (
  <SuccessCard>
    <SuccessIconWrapper>
      <Image src="greenCheck.svg" width={58} height={58} alt="Success" />
    </SuccessIconWrapper>
    <H2 color="var(--color-text-primary)">WhatsApp updates enabled</H2>
    <SuccessDescription>
      {`We'll send the child's reports to ${formatPhoneDisplay(
        country,
        phone
      )}. You can manage this at any time from Settings.`}
    </SuccessDescription>
    <BenefitsList>
      {PARENT_PROGRESS_BENEFITS.map(({ icon, title, description }) => (
        <BenefitItem key={title}>
          <BenefitIcon>
            <Image src={icon} width={32} height={32} alt={title} />
          </BenefitIcon>
          <div>
            <BenefitTitle>{title}</BenefitTitle>
            <BenefitDescription>{description}</BenefitDescription>
          </div>
        </BenefitItem>
      ))}
    </BenefitsList>
    <SuccessContinueButton
      label="Continue"
      variant="filled"
      onClick={onContinue}
      color="green"
    />
  </SuccessCard>
);

export default ParentContactVerificationSuccess;
